import React, { Component }from 'react';

export class Error extends Component {
  constructor(props) {
    super(props);
    this.store = props.store;
    this.error = props.error;
    this.msg = props.msg;
  }
  render() {
    return (
      <div>
        <div style={{fontSize: '18pt', margin: '2em'}}>
          <div>
            {this.msg}: {this.error}
          </div>
          <div>
            Please refresh and try again.
            If the problem persists, please contact the administrator with
            the following information:
          </div>
          <div style={{fontFamily: 'mono', fontSize: '12pt'}}>
            <pre>
              {JSON.stringify(this.store.debugInfo(), null, 2)}
            </pre>
          </div>
        </div>
      </div>
    );
  }
}

